import { Outlet, useLocation } from 'react-router-dom';
import { BottomNav, Sidebar } from './Navigation';

// Le schermate "pushed"/modali (dettaglio, form) nascondono la bottom nav su
// mobile per dare priorità alla loro action bar fissa (README §3/§6).
const FULLSCREEN_PREFIXES = ['/nuovo', '/profilo/modifica', '/profilo/sicurezza'];

export function Layout() {
  const { pathname } = useLocation();
  const hideBottomNav = FULLSCREEN_PREFIXES.some((p) => pathname.startsWith(p));

  return (
    <div className="shell">
      {/* Glow decorativi (visibili solo in Aurora). */}
      <div className="glow glow--1" aria-hidden />
      <div className="glow glow--2" aria-hidden />

      <Sidebar />
      <main className="shell__main">
        <Outlet />
      </main>
      {!hideBottomNav && <BottomNav />}
    </div>
  );
}
